export const SENDING_EMAIL_LOADING_MODAL = 'SENDING_EMAIL_LOADING_MODAL';
export const EMAIL_SENT_MODAL = 'EMAIL_SENT_MODAL';
export const FORGOT_PASSWORD_SUCCESS_MODAL = 'FORGOT_PASSWORD_SUCCESS_MODAL';
export const INACTIVE_USER_MODAL = 'INACTIVE_USER_MODAL';
export const HELP_AND_SUPPORT_MODAL = 'HELP_AND_SUPPORT_MODAL';
export const PAYMENT_FAILED_MODAL = 'PAYMENT_FAILED_MODAL';
export const PAYMENT_PROCESSING_MODAL = 'PAYMENT_PROCESSING_MODAL';
export const FEATURE_DETAILS_MODAL = 'FEATURE_DETAILS_MODAL';
export const BILLING_LOAD_ERROR_MODAL = 'BILLING_LOAD_ERROR_MODAL';
export const REACTIVATE_PLAN_MODAL = 'REACTIVATE_PLAN_MODAL';
export const REACTIVATING_PLAN_LOADING_MODAL =
  'REACTIVATING_PLAN_LOADING_MODAL';
export const CANCEL_SCHEDULED_CHANGE_MODAL = 'CANCEL_SCHEDULED_CHANGE_MODAL';
export const CANCELING_SCHEDULED_CHANGE_LOADING_MODAL =
  'CANCELING_SCHEDULED_CHANGE_LOADING_MODAL';
export const SUSPENDED_MODAL = 'SUSPENDED_MODAL';
export const INCOMPLETE_BILLING_MODAL = 'INCOMPLETE_BILLING_MODAL';
